import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from './SectionTitle';
import Button from './Button';
import { ArrowRight } from 'lucide-react';

const aboutContent = {
  heading: 'के बारे में',
  name: 'श्री. संजय ह. परदेशी',
  description: `\
श्री. संजय ह. परदेशी मेकॅनिकल इंजीनिअर हैं। पिछले ३० वर्षों से अपने कारोबार में लगे हुए हैं। साथ ही पिछले २० वर्षों से समाजसेवा और राष्ट्रसेवा करते हुए उनका लक्ष्य भारत की समस्याओं पर समाधान ढूंढना है।\
भारत की प्रमुख समस्याओं पर निरंतर चिंतन करते हुए उन्होंने 'भारत कैसे बदले..?' और 'सीधी सोच, सीधी बात..!' इस खुले मंच के तहत समस्याओं पर समाधान प्रस्तुत किए हैं।\
उनका मानना है कि जब तक न्यायव्यवस्था और शिक्षाव्यवस्था में मूलभूत बदलाव नहीं होंगे, तब तक भारत की बाकी समस्याओं पर भी संपूर्ण समाधान नहीं मिलेगा।\
उन्होंने सड़क दुर्घटनाएं और यातायात की समस्याओं पर भी समाधान ढूंढकर 'संपूर्ण भारत की नई सड़क और यातायात योजना' बनाई है।\
`,
  button: 'बायो देखें',
  image: '/images/sp1.jpeg',
  aboutUrl: '/about',
};

const AboutSection = () => (
  <section
  id="about"
  className="w-full py-4 px-4 md:px-0 flex flex-col md:flex-row items-center justify-center bg-[#fcf8ee]"
>
  {/* Mobile/Tablet: Title first, then image, then name/text/button */}
  <div className="block md:hidden w-full">
    <SectionTitle>परिचय</SectionTitle>
    <div className="flex flex-col items-center">
      <img
        src={aboutContent.image}
        alt="संजय परदेशी"
        className="rounded-2xl shadow-2xl w-full max-w-xs sm:max-w-sm h-auto mx-auto mb-4"
        style={{ minHeight: '180px', maxHeight: '', boxShadow: '0 8px 32px 0 rgba(0,0,0,0.18)' }}
      />
      <h2 className="text-xl font-extrabold mb-2 text-gray-900 text-center" style={{ fontWeight: 800 }}>
        {aboutContent.name}
      </h2>
      <div className="h-1 w-16 bg-orange-500 rounded mb-4 mx-auto" />
      <p className="text-gray-700 text-base mb-6 whitespace-pre-line leading-relaxed text-center">
        {aboutContent.description}
      </p>
      <Button to={aboutContent.aboutUrl} size="sm" rightIcon={ArrowRight} className="mt-2 mx-auto">
        और पढ़ें
      </Button>
    </div>
  </div>

  {/* Desktop: Image left, text right */}
  <div className="hidden md:flex flex-1 flex-row items-center justify-center w-full">
    {/* Left: Image */}
    <div className="flex-1 flex justify-center items-center">
      <img
        src={aboutContent.image}
        alt="संजय परदेशी"
        className="rounded-2xl shadow-2xl w-full max-w-xl object-cover"
        style={{
          maxHeight: '400px', // Ensure the image height is consistent with text height
          width: 'auto', // Maintain aspect ratio
          boxShadow: '0 8px 32px 0 rgba(0,0,0,0.18)',
        }}
      />
    </div>

    {/* Right: About Text */}
    <div
      className="flex-1 flex flex-col justify-center items-start mx-auto md:mx-0"
      style={{
        background: '#fff8ee',
        borderRadius: '18px',
        padding: '1.5rem 2rem',
        fontFamily: 'Mukta, Arial, sans-serif',
        boxShadow: 'none',
      }}
    >
      <SectionTitle>परिचय</SectionTitle>
      <h2 className="text-2xl md:text-3xl font-extrabold mb-2 text-gray-900" style={{ fontWeight: 800 }}>
        {aboutContent.name}
      </h2>
      <div className="h-1 w-16 bg-orange-500 rounded mb-4" />
      <p className="text-gray-700 text-base md:text-lg mb-8 whitespace-pre-line leading-relaxed">
        {aboutContent.description}
      </p>
      <Button to={aboutContent.aboutUrl} size="sm" rightIcon={ArrowRight} className="mt-2">
        और पढ़ें
      </Button>
    </div>
  </div>
</section>

);

export default AboutSection; 